import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import useInvoiceMonthlies from '../useInvoiceMonthlies';

const MainPage = () => {
  const { data, columns, loading, filters, onChangeTableFilter, onDelete } =
    useInvoiceMonthlies(true);
  const { t } = useTranslation();

  const { ability = {} } = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('Fatturato semestrale/annuale').toUpperCase()}>
        <Row gutter={16}>
          {ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.invoice_years}
          pagination={data.pagination}
          scroll={{ x: 1500 }}
          loading={loading}
          onChange={onChangeTableFilter}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={<DeleteModal loading={loading} onClickDelete={onDelete} />}
        />
      </Routes>
    </>
  );
};

export default MainPage;
